import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function HowToUse() {
  const steps = [{
    step: 1,
    instruction: 'Clean, dry skin',
    detail: 'Ensure the knee area is clean and completely dry before application'
  }, {
    step: 2,
    instruction: 'Center over kneecap; press 10–15 seconds',
    detail: 'Place the patch directly over the center of your kneecap and press firmly for 10-15 seconds to ensure proper adhesion'
  }, {
    step: 3,
    instruction: 'Gently heat with hands',
    detail: 'After applying, rub the patch gently with your hands for a few seconds to activate and enhance the warming effect'
  }, {
    step: 4,
    instruction: 'Wear up to 6–8 hours; remove slowly',
    detail: 'For best results, wear for up to 6-8 hours. Remove slowly by gently pulling from one edge'
  }];
  const dos = ['Apply to clean, dry skin', 'Ensure application site has little to no hair for best adhesion', 'Gently rub the patch with your hands after applying to enhance warming', 'Use one patch per knee as needed', 'Wear under loose clothing if desired', 'Remove if skin irritation occurs'];
  const donts = ["Don't use on broken or irritated skin", "Don't layer with heat creams", "Don't use during pregnancy without clinician approval", "Don't use on children under 12"];
  return <section className="py-12 bg-[#EAF7F3]" data-id="element-183">
      <div className="container mx-auto px-4" data-id="element-184">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-[#0E6B6B]" data-id="element-185">
          How To Use
        </h2>
        <div className="max-w-3xl mx-auto" data-id="element-186">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-10" data-id="element-187">
            {steps.map(step => <div key={step.step} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-188">
                <div className="w-10 h-10 bg-[#0E6B6B] text-white rounded-full flex items-center justify-center font-bold mb-4" data-id="element-189">
                  {step.step}
                </div>
                <h3 className="font-bold mb-2" data-id="element-190">{step.instruction}</h3>
                <p className="text-sm text-gray-700" data-id="element-191">{step.detail}</p>
              </div>)}
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm mb-8" data-id="element-192">
            <h3 className="font-bold mb-4" data-id="element-193">Two-knee guidance:</h3>
            <p className="mb-6" data-id="element-194">Using both knees? Apply two patches daily.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-195">
              <div data-id="element-196">
                <h4 className="font-bold flex items-center mb-3 text-[#35A67E]" data-id="element-197">
                  <CheckIcon size={20} className="mr-2" data-id="element-198" />
                  Do's
                </h4>
                <ul className="space-y-2" data-id="element-199">
                  {dos.map((item, index) => <li key={index} className="flex items-start" data-id="element-200">
                      <CheckIcon size={16} className="text-[#35A67E] mr-2 mt-1" data-id="element-201" />
                      <span data-id="element-202">{item}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-203">
                <h4 className="font-bold flex items-center mb-3 text-red-500" data-id="element-204">
                  <XIcon size={20} className="mr-2" data-id="element-205" />
                  Don'ts
                </h4>
                <ul className="space-y-2" data-id="element-206">
                  {donts.map((item, index) => <li key={index} className="flex items-start" data-id="element-207">
                      <XIcon size={16} className="text-red-500 mr-2 mt-1" data-id="element-208" />
                      <span data-id="element-209">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-210">
            <h3 className="font-bold mb-4" data-id="element-211">Additional Notes:</h3>
            <p className="mb-2" data-id="element-212">
              <span className="font-medium" data-id="element-213">Sleep:</span> OK to sleep with
              patches if comfortable.
            </p>
            <p data-id="element-214">
              <span className="font-medium" data-id="element-215">Shower:</span> Remove patches before
              bathing or showering.
            </p>
          </div>
        </div>
      </div>
    </section>;
}